const initState = {
  cityRequests: [],
  hasMoreDocument: false,
  lastDocument: null,
};

const requestedCitiesReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_CITY_REQUEST":
      return {
        ...state,
        cityRequests: action.payload.data,
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_CITY_REQUEST_MORE":
      return {
        ...state,
        cityRequests: [...state.cityRequests, ...action.payload.data],
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default requestedCitiesReducer;
